<template>
  <section ref="counters" class="counters__inner">
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-NLXLWDC"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe>
    </noscript>

    <noscript>
      <div style="position:absolute;left:-10000px;">
        <img
          src="//top-fwz1.mail.ru/counter?id=2135728;js=na"
          style="border:0;"
          height="1"
          width="1"
          alt="Рейтинг@Mail.ru"
        />
      </div>
    </noscript>

    <noscript>
      <div>
        <img src="//mc.yandex.ru/watch/27036375" style="position:absolute; left:-9999px;" alt="" />
      </div>
    </noscript>
  </section>
</template>

<script>
export default {
  name: "MailCounters",

  data() {
    return {};
  },

  mounted() {
    let counters = this.$refs.counters;

    let footer_mr = document.createElement("script");
    footer_mr.innerHTML = `var footer_mr = (typeof (footer_mr) != 'undefined') ? footer_mr : '305',
    footer_li = (typeof (footer_li) != 'undefined') ? footer_li : '25.5';`;
    counters.appendChild(footer_mr);

    let one_link = document.createElement("script");
    one_link.setAttribute(
      "src",
      "https://wf.cdn.gmru.net/static/wf.mail.ru/js/1link_processing.js"
    );
    counters.appendChild(one_link);

    let google_counter = document.createElement("script");
    google_counter.innerHTML = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-NLXLWDC');`;
    counters.appendChild(google_counter);

    let mailru_counter = document.createElement("script");
    mailru_counter.innerHTML = `var _tmr = _tmr || [];
      _tmr.push({ id: "2135728", type: "pageView", start: (new Date()).getTime() });
      (function (d, w) {
        var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true;
        ts.src = (d.location.protocol == "https:" ? "https:" : "http:") + "//top-fwz1.mail.ru/js/code.js";
        var f = function () { var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s); };
        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
      })(document, window);`;
    counters.appendChild(mailru_counter);

    let yandex_metrika = document.createElement("script");
    yandex_metrika.innerHTML = `(function (d, w, c) {
        (w[c] = w[c] || []).push(function () {
          try {
            w.yaCounter27036375 = new Ya.Metrika({
              id: 27036375,
              webvisor: true,
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true
            });
          } catch (e) { }
        });
        var n = d.getElementsByTagName("script")[0],
          s = d.createElement("script"),
          f = function () { n.parentNode.insertBefore(s, n); };
        s.type = "text/javascript";
        s.async = true;
        s.src = (d.location.protocol == "https:" ? "https:" : "http:") + "//mc.yandex.ru/metrika/watch.js";
        if (w.opera == "[object Opera]") {
          d.addEventListener("DOMContentLoaded", f, false);
        } else { f(); }
      })(document, window, "yandex_metrika_callbacks");`;
    counters.appendChild(yandex_metrika);
  },
};
</script>
